import React from 'react'
import ErrorModal from '../../../ErrorModal'
import { FormlessJourneyProps } from '../FormlessJourney'
import withDetectRefresh from '../../../HOC/withDetectRefresh'
import FormlessJourneyV4InterstitialWrapper from './FormlessJourneyV4InterstitialWrapper'
import ConflictErrorModalContent from '../../../ErrorModal/ConflictErrorModalContent'

const FormlessJourneyV4Wrapper = ({
  experimentName,
  attribution,
  isPreapproved,
  lenderDetails,
  // injected props from HOC
  apiError,
  conflictError,
  redirectUrl,
  closeError
}: FormlessJourneyProps) => {
  return (
    <>
      {conflictError && (
        <ErrorModal ctaText="Close" onClick={closeError}>
          <ConflictErrorModalContent />
        </ErrorModal>
      )}
      {apiError && (
        <ErrorModal
          titleText="Sorry"
          ctaText="Please try again"
          onClick={closeError}
        >
          There was a problem submitting your application
        </ErrorModal>
      )}

      {!apiError && !conflictError && attribution && (
        <FormlessJourneyV4InterstitialWrapper
          source={attribution.source}
          experimentName={experimentName}
          isPreapproved={isPreapproved}
          lenderDetails={lenderDetails}
          redirectUrl={redirectUrl}
        />
      )}
    </>
  )
}

export default withDetectRefresh(FormlessJourneyV4Wrapper)
